import { EnvironmentInsightDTO } from '../../dto';

export interface Props {
  svanen?: {
    svanenCertificateId?: string;
  };
  euBlomman?: {
    euBlommanCertificateId?: string;
  };
  basta: boolean | null;
  bastaBeta: boolean | null;
  bastaDeklarerad: boolean | null;

  sundahusAssessment?: {
    sundahusAssessment: string;
  };
  blueAngel: boolean | null;
  bvb?: {
    bvbAssessmentTotal: string;
    bvbAssessmentUrl: string;
    bvbCertificateId: string;
  };
  ebvd: boolean | null;
  euEcoLabel: boolean | null;
  braMiljoval: boolean | null;
  fscCertified: boolean | null;
  pefcCertified: boolean | null;
}

export class EnvironmentInsight {
  svanen?: {
    svanenCertificateId?: string;
  };
  euBlomman?: {
    euBlommanCertificateId?: string;
  };
  basta: boolean | null;
  bastaBeta: boolean | null;
  bastaDeklarerad: boolean | null;

  sundahusAssessment?: {
    sundahusAssessment: string;
  };
  blueAngel: boolean | null;
  bvb?: {
    bvbAssessmentTotal: string;
    bvbAssessmentUrl: string;
    bvbCertificateId: string;
  };
  ebvd: boolean | null;
  euEcoLabel: boolean | null;
  braMiljoval: boolean | null;
  fscCertified: boolean | null;
  pefcCertified: boolean | null;

  constructor({
    svanen,
    euBlomman,
    basta,
    bastaBeta,
    bastaDeklarerad,
    sundahusAssessment,
    blueAngel,
    bvb,
    ebvd,
    euEcoLabel,
    braMiljoval,
    fscCertified,
    pefcCertified,
  }: Props) {
    this.svanen = svanen;
    this.euBlomman = euBlomman;
    this.basta = basta;
    this.bastaBeta = bastaBeta;
    this.bastaDeklarerad = bastaDeklarerad;
    this.sundahusAssessment = sundahusAssessment;
    this.blueAngel = blueAngel;
    this.bvb = bvb;
    this.ebvd = ebvd;
    this.braMiljoval = braMiljoval;
    this.euEcoLabel = euEcoLabel;
    this.fscCertified = fscCertified;
    this.pefcCertified = pefcCertified;
  }

  static fromDto = (dto: EnvironmentInsightDTO): EnvironmentInsight =>
    new EnvironmentInsight({
      svanen: dto.svanen,
      euBlomman: dto.euBlomman,
      basta: dto.basta,
      bastaBeta: dto.bastaBeta,
      bastaDeklarerad: dto.bastaDeklarerad,
      sundahusAssessment: dto.sundahusAssessment,
      blueAngel: dto.blueAngel,
      bvb: dto.bvb,
      ebvd: dto.ebvd,
      euEcoLabel: dto.euEcoLabel,
      braMiljoval: dto.braMiljoval,
      fscCertified: dto.fscCertified,
      pefcCertified: dto.pefcCertified,
    });
}
